import type { CSSProperties } from "react";
import { twMerge } from "tailwind-merge";
import styles from "./circular-progress.module.css";

const SIZE = 44;

export interface CircularProgressProps {
  className?: string;
  size?: number;
  thickness?: number;
  style?: CSSProperties;
}

export const CircularProgress = ({
  className,
  size = 40,
  thickness = 4.2,
  style,
}: CircularProgressProps) => {
  return (
    <div
      className={twMerge(
        styles.circularProgress,
        "text-primary-500 progress inline-block",
        className,
      )}
      style={{ width: size, height: size, ...style }}
      role="progressbar"
    >
      <svg viewBox={`${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`}>
        <circle
          className="stroke-current transition-all"
          style={{ strokeDasharray: "80px, 200px", strokeDashoffset: 0 }}
          cx={SIZE}
          cy={SIZE}
          r={(SIZE - thickness) / 2}
          fill="none"
          strokeWidth={thickness}
        />
      </svg>
    </div>
  );
};
